import React from "react";
import {
  Box,
  Button,
  Typography,
  TableHead,
  TableRow,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  Tooltip,
} from "@mui/material";
import dayjs from "dayjs";
import ContentModal from "components/ContentModal"; // Assuming this is a custom modal component

const ConfirmationModal = ({
  policiesData,
  adoptionOptions,
  handleClose,
  handleGoBack,
  handleSave,
  handleSaveAsDraft,
  showDraftButton,
}) => {
  //disable save button if there are not policies or any policy has an lob without an adoption decision
  const isDisabled = function (policiesData) {
    if (policiesData.length === 0) {
      return true;
    }

    for (let i = 0; i < policiesData.length; i++) {
      const policy = policiesData[i];
      for (let j = 0; j < policy.lineOfBusinessDetailsList.length; j++) {
        const lob = policy.lineOfBusinessDetailsList[j];
        if (!lob.adoptionDecision || lob.adoptionDecision === "") {
          return true;
        }
      }
    }

    return false;
  };

  //returns a tool tip if save button is disabled based on context
  const toolTipMessage = function (policiesData) {
    if (policiesData.length === 0) {
      return "No adoption decisions to save.";
    }
    if (isDisabled(policiesData)) {
      return "Ensure all lines of buisiness have entered adoption decisions.";
    } else return null;
  };

  return (
    <ContentModal
      open={true}
      handleClose={handleClose}
      maxWidth={"lg"}
      title={
        <Box
          sx={{
            display: "flex",
            fontWeight: "bold",
            width: "100%",
          }}
        >
          <span>{`Confirm Adoption Decisions: ${policiesData.length} ${policiesData.length <= 1 ? "Policy" : "Policies"}`}</span>
        </Box>
      }
      content={
        <Box>
          {policiesData
            .sort((a, b) => {
              return a.policyNumber.localeCompare(b.policyNumber, undefined, {
                numeric: true,
                sensitivity: "base",
              });
            })
            .map((policy) => (
              <Box key={policy.policyKey} sx={{ mb: 3 }}>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: "bold" }}
                  gutterBottom
                >
                  {" "}
                  {/* Change this variant to avoid nesting inside another heading */}
                  Policy: {policy.policyNumber} - {policy.policyTitle}
                </Typography>
                <TableContainer>
                  <Table>
                    <TableHead>
                      <TableRow
                        sx={{
                          "&>*": {
                            minWidth: "200px",
                          },
                        }}
                      >
                        <TableCell>
                          <Typography fontWeight={"bold"}>
                            Line of Business
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography fontWeight={"bold"}>
                            Adoption Decision
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography fontWeight={"bold"}>
                            Effective day
                          </Typography>
                        </TableCell>

                        <TableCell>
                          <Typography fontWeight={"bold"}>
                            Variance comments
                          </Typography>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {policy.lineOfBusinessDetailsList.map((lob) => {
                        const adoptionDecisionDesc =
                          adoptionOptions.find(
                            (option) =>
                              option.statusCode === lob.adoptionDecision
                          )?.statusDescription || "Unknown Status";
                        return (
                          <TableRow
                            sx={{
                              "&>*": {
                                minWidth: "200px",
                              },
                            }}
                            key={lob.id}
                          >
                            <TableCell>
                              <Typography variant="body1">
                                {lob.lobDesc}{" "}
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Typography variant="body1">
                                {adoptionDecisionDesc}
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Typography variant="body1">
                                {lob.effectiveDate
                                  ? dayjs(lob.effectiveDate).format(
                                      "MM/DD/YYYY"
                                    )
                                  : "N/A"}
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Typography variant="body1">
                                {lob.varianceComments}
                              </Typography>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            ))}
        </Box>
      }
      actions={
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <Box>
            <Button onClick={handleGoBack}>Go Back</Button>
          </Box>
          <Tooltip
            title={toolTipMessage(policiesData)}
            data-testid="save-tooltip"
          >
            <span>
              <Button
                onClick={handleSave}
                disabled={isDisabled(policiesData)}
                variant="contained"
                color="primary"
              >
                SAVE
              </Button>
            </span>
          </Tooltip>
          {showDraftButton && (
            <span>
              <Button
                onClick={handleSaveAsDraft}
                disabled={isDisabled(policiesData)}
                variant="contained"
                color="primary"
              >
                SAVE AS DRAFT
              </Button>
            </span>
          )}
        </Box>
      }
    />
  );
};

export default ConfirmationModal;
